<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm :defaultValues="{ blocked: false, __v: 0, order: 0, useTimesAggr: 0, useTimesProxy: 0 }" create
              title="Create proxy country use" @finish="handleItemsUpdate">
              <template #button="{ onclick }">
                <b-button type="button" variant="success" @click="onclick"><i class="fas fa-plus"></i> Create</b-button>
              </template>
            </EditForm>
          </div>
        </div>

        <div class="row col-lg-12">
          <div class="form-group col-sm-3">
            <label>Domain</label>
            <b-form-input v-model="filters.domain" placeholder="center.domain.com" />
          </div>
          <div class="form-group col-sm-2">
            <label>Country</label>
            <b-form-input v-model="filters.country" placeholder="US" maxlength="2" />
          </div>
          <div class="form-group col-sm-3" style="padding-top: 32px;">
            <b-button type="button" variant="primary" class="mr-2" @click="applyFiltersNow">Search</b-button>
            <b-button type="button" variant="secondary" @click="resetFilters">Reset</b-button>
          </div>
        </div>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="scroll-wrapper">
                <div class="scroll"></div>
              </div>
              <div class="table-wrapper mb-10">
                <b-table :striped="true" :small="true" :hover="true" :empty-text="emptyText" show-empty :busy="!!cancel"
                  :items="items" :fields="fields" :no-local-sorting="true" :sort-icon-left="true"
                  @sort-changed="sortingChanged">
                  <template #cell(actions)="row">
                    <EditForm :defaultValues="{ ...row.item }" title="Edit proxy country use" @finish="handleItemsUpdate" />
                    <RemoveForm :object="row.item.id" message="Please confirm removing item"
                      :url="'/api/v1/proxy-country-use/' + row.item.id" @finish="handleItemsUpdate" />
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <b-pagination class="float-right" v-model="pagination.page" :total-rows="pagination.records"
                  :per-page="pagination.onPage" @change="onPageChange" first-number last-number />
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <ve-pagination class="float-right" :page-index="pagination.page" :page-size="pagination.onPage"
                  :total="pagination.records" :pagingCount="pagination.count" :layout="['total', 'sizer']"
                  :pageSizeOption="pagination.pageSizeOption" @on-page-size-change="onPageSizeChange" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import EditProxyCountryUseForm from "../../components/ProxyCountryUse/EditProxyCountryUseForm.vue";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";
import axios from "axios";
import { getRouteIcon, ROUTE_PROXY } from "../../utils/routerIcons";

function getDefaultPagination() {
  return {
    onPage: 25,
    page: 1,
    records: 0,
    count: 5,
    pageSizeOption: [25, 50, 100, 200],
  };
}

export default {
  components: {
    EditForm: EditProxyCountryUseForm,
    RemoveForm,
  },
  data() {
    return {
      cancel: null,
      error: null,
      fields: [
        { key: 'id', label: '_ID', sortable: true, },
        { key: 'blocked', label: 'Blocked', sortable: true, },
        { key: 'country', label: 'Country', sortable: true, },
        { key: 'domain', label: 'Domain', sortable: true, },
        { key: 'order', label: 'Order', sortable: true, },
        { key: 'useTimesAggr', label: 'useTimesAggr', sortable: true, },
        { key: 'useTimesProxy', label: 'useTimesProxy', sortable: true, },
        { key: 'actions', label: 'Actions', }
      ],
      sortBy: null,
      sortDesc: null,
      items: [],
      filters: { domain: '', country: '' },
      pagination: getDefaultPagination(),
    }
  },
  computed: {
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_PROXY),
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.pagination.page = 1;
      this.loadItems();
    },
    handleItemsUpdate() {
      this.loadItems();
    },
    applyFiltersNow() {
      this.pagination.page = 1;
      this.loadItems();
    },
    resetFilters() {
      this.filters.domain = '';
      this.filters.country = '';
      this.pagination.page = 1;
      this.loadItems();
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];
      let self = this;
      loadingInstance.show();

      this
        .$http({
          url: '/api/v1/proxy-country-use',
          params: {
            limit: this.pagination.onPage,
            offset: this.pagination.onPage * (this.pagination.page - 1),
            orderBy: this.sortBy,
            direction: this.sortDesc ? 'DESC' : 'ASC',
            domain: this.filters.domain,
            country: (this.filters.country || '').toUpperCase(),
          },
          method: 'GET',
          cancelToken: new axios.CancelToken(c => { self.cancel = c }),
        })
        .then(resp => {
          let { items, pagination: { limit, totalCount } } = resp.data;
          this.items = items;
          this.pagination.onPage = limit;
          this.pagination.records = totalCount;
        })
        .catch((err) => {
          this.items = [];
          this.error = err;
        })
        .finally(() => {
          loadingInstance.close();
          this.cancel = null;
        });
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1;
      this.pagination.onPage = pageSize;
      this.loadItems();
    },
  },
  mounted() {
    this.loadItems();
  }
}
</script>

